import { UTILS } from "../utils";

var CONFIG = {
    platform: 'wechat',

    // 本地开发环境URL配置:
    // qq_url: 'http://prewx.yxdxt.com/qq',
    // wechat_url: 'http://prewx.yxdxt.com/',

    // 预发布环境URL配置:
    // qq_url: 'https://qq.yxdxt.com',
    // wechat_url: 'https://prewx.yxdxt.com/',
    
    // 正式环境URL配置:
    web_url: 'https://b.yxdxt.com',
    qq_url: 'https://qq.yxdxt.com/qq',
    wechat_url: 'https://wx.yxdxt.com/',
    ly_url: 'https://ly.yxdxt.com',

    // api接口地址及api基础参数配置
    api_url: 'https://api.yxdxt.com/api',
    // api_url: 'https://pre.yxdxt.com/api',
    platform_params: {
        platform: 3,
        version: '4.6.8',
        time: (new Date()).getTime() / 1000
    },

    // 下载地址
    // ios_url: 'https://testflight.apple.com/join/bdPtq3I0',
    ios_url: 'https://apps.apple.com/cn/app/%E5%A4%A9%E6%97%B6%E5%AD%90%E5%B9%B3%E7%94%9F%E8%BE%B0%E5%85%AB%E5%AD%97-%E5%91%BD%E7%90%86%E7%B2%BE%E5%93%81/id1471841010',
    android_url: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.muhuo.bz',

    // 协议地址
    agree_url: 'http://wx.yxdxt.com/agreement/index.html',
    privacy_url: 'http://wx.yxdxt.com/agreement/privacy.html',
    download_url: 'http://wx.yxdxt.com/download/index.html',

    // 支付折扣
    character_discount: 0.5,
    vip_discount: 1,
    
    // vip弹框显示时间和次数配置
    vip_show_time: 3,
    vip_count_time: 300,

    // 公众号地址
    home_url: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIxMTY5Njc3Ng==#wechat_redirect',
    // banner链接地址
    banner_url: 'https://appmzhzthq89078.h5.xiaoeknow.com/',

    // 拼接微信授权的链接地址,回调地址为当前路径
    getWechatAuthUrl() {
        var shareId = UTILS.getQueryString("shareid");
        var wechatAuthUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5ad7cac8f1889c58&redirect_uri=";
        wechatAuthUrl = wechatAuthUrl + window.encodeURIComponent('https://' + window.location.hostname + window.location.pathname);
        if(shareId){
            wechatAuthUrl = wechatAuthUrl + '?shareid=' + shareId;
        }
        wechatAuthUrl = wechatAuthUrl + "&response_type=code&scope=snsapi_userinfo&forcePopup=true&forceSnapShot=true&state=web&connect_redirect=1#wechat_redirect";
        console.error("wechatAuthUrl---", wechatAuthUrl)
        return wechatAuthUrl;
    }, 
}

export {
    CONFIG
}